export var AuthBrowserErrorType;
(function (AuthBrowserErrorType) {
    /**
     * This error is the result of passing an invalid or malformed url to ´AuthBrowserOpenOptions´.
     */
    AuthBrowserErrorType["invalidUrl"] = "invalidUrl";
    /**
     * This error is the result of redirect scheme not present in ´AuthBrowserOpenOptions´.
     */
    AuthBrowserErrorType["redirectSchemeNotFound"] = "redirectSchemeNotFound";
    /**
     * This error is the result of the validation of the url in ´AuthBrowserOpenOptions´ is not present in navigation whitelist
     */
    AuthBrowserErrorType["urlNotAllowed"] = "urlNotAllowed";
    /**
     * This error occurrs when a session is already in progress
     */
    AuthBrowserErrorType["sessionAlreadyInProgress"] = "sessionAlreadyInProgress";
    /**
     * This error is the result of the user has closed the browser before the session is complete
     */
    AuthBrowserErrorType["browserClosedByUser"] = "browserClosedByUser";
    /**
     * This error is the result of the validation of the callback url in ´AuthBrowserOpenResponse´ is not present
     * You might need to refer to the authentication service
     */
    AuthBrowserErrorType["missingCallbackURL"] = "missingCallbackURL";
    /**
     * This error is reserver for unknown errors.
     */
    AuthBrowserErrorType["unknownError"] = "unknownError";
})(AuthBrowserErrorType || (AuthBrowserErrorType = {}));
//# sourceMappingURL=authbrowser.js.map